import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import DownPaymentPercentInput from '../down-payment-percent';

const DownPaymentPercentInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  className,
  fullWidth,
}) => {
  return (
    <DownPaymentPercentInput className={className} fullWidth={fullWidth} />
  );
};

export default DownPaymentPercentInputWithAnalytics;
